import { ChannelList, ChannelListProps } from 'stream-chat-react';
import { MessagingChannelPreview } from '../view/MessagingChannelPreview/MessagingChannelPreview';

type MessagingSidebarProps = {
  channelListOptions: Pick<ChannelListProps, 'filters' | 'sort' | 'options'>;
} & {
  blockChannel: (id: string) => void;
  showUserInfo: (id: string) => void;
};

export const MessagingSidebar = ({
  channelListOptions,
  blockChannel,
  showUserInfo,
}: MessagingSidebarProps) => (
  <div className="str-chat messaging__sidebar str-chat__theme-light">
    <ChannelList
      {...channelListOptions}
      Preview={(p) => (
        <MessagingChannelPreview
          {...p}
          blockChannel={blockChannel}
          showUserInfo={showUserInfo}
        />
      )}
    />
  </div>
);
